// @ts-nocheck
// The week strip (docs/FREE_WEEK_MESSAGING.md 4, snippets/vhp-week-strip.liquid, styles assets/vhp-week-strip.css):
// builds once when half of it is on screen (tiles in, badges, the sum counting up), then stays. Reduced motion,
// Save-Data or no IntersectionObserver: everything is simply there. Also the "So funktioniert's" pill under a strip
// ([data-vws-how="<dialog id>"]) that opens the film sheet.
(() => {
  'use strict';

  if (window.vhpWeekStrip) return;
  window.vhpWeekStrip = true;

  const still = () => {
    try {
      return Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData);
    } catch (e) {
      return false;
    }
  };

  // The sum ("über 45 Mio.") counts from 0 to its number in 0.8 s, ease-out.
  const countUp = (el) => {
    const n = Number(el.dataset.vwsN || el.textContent);
    if (!n) return;
    const dur = 800;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(n * e));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const arm = (strip) => {
    if (strip.dataset.vwsArmed) return;
    strip.dataset.vwsArmed = '1';
    if (still() || !('IntersectionObserver' in window)) {
      strip.classList.add('is-in');
      return;
    }
    strip.classList.add('vws--anim');
    const sum = strip.querySelector('[data-vws-n]');
    if (sum) sum.textContent = '0';
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((en) => en.isIntersecting)) return;
        io.disconnect();
        strip.classList.add('is-in');
        if (sum) window.setTimeout(() => countUp(sum), 1000);
      },
      { threshold: 0.5 }
    );
    io.observe(strip);
  };

  let queued = false;
  const scan = () => {
    queued = false;
    document.querySelectorAll('[data-vws]').forEach(arm);
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  };

  document.addEventListener('click', (event) => {
    const how = event.target instanceof Element ? event.target.closest('[data-vws-how]') : null;
    if (!how) return;
    const sheet = document.getElementById(how.dataset.vwsHow || '');
    if (!sheet) return;
    event.preventDefault();
    if (window.vhpSheet) window.vhpSheet.setOpen(sheet, true);
    else if (!sheet.open) sheet.showModal();
    window.vhpPlannerEvents?.step('planner_block', 'how_end');
  });

  scan();
  // Strips that arrive later (the recipe sheet loads its body by fetch, screens un-hide).
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
